import React from "react";
import { Modal, Tag, Button } from "antd";
import {
  PlayCircleOutlined,
  PauseCircleOutlined,
  ControlOutlined,
  FileTextOutlined,
  MessageOutlined,
  DeleteOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { STATUS_COLOR_MAP } from "../../hooks/useBotFilters";

/**
 * 管理假人模态框 — 查看详情 + 启动/停止 + 控制 + 日志 + 聊天记录 + 删除 + 配置
 */
const ManageBotModal = ({
  visible,
  bot,
  loading,
  onStartStop,
  onOpenControl,
  onOpenLogs,
  onOpenChats,
  onDelete,
  onOpenConfig,
  onCancel,
}) => {
  if (!bot) return null;

  const isRunning = bot.status === "在线" || bot.status === "启动中";

  return (
    <Modal
      title={`管理假人 - ${bot.name || ""}`}
      open={visible}
      onCancel={onCancel}
      footer={null}
      className="botcontrol-modal"
      width={500}
    >
      <div className="management-modal-content">
        <div className="botcontrol-details" style={{ marginBottom: "20px" }}>
          <div className="botcontrol-detail-item">
            <span className="botcontrol-detail-label">服务器: </span>
            <span className="botcontrol-detail-value">
              {bot.host}:{bot.port}
            </span>
          </div>
          <div className="botcontrol-detail-item">
            <span className="botcontrol-detail-label">状态: </span>
            <span className="botcontrol-detail-value">
              <Tag color={STATUS_COLOR_MAP[bot.status]}>{bot.status}</Tag>
            </span>
          </div>
          <div className="botcontrol-detail-item">
            <span className="botcontrol-detail-label">最后活动: </span>
            <span className="botcontrol-detail-value">
              {bot.last_activity}
            </span>
          </div>
        </div>

        <div className="management-options">
          <Button
            type="primary"
            icon={isRunning ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
            onClick={() => onStartStop(bot)}
            loading={loading}
            style={{
              width: "100%",
              marginBottom: "10px",
              height: "40px",
            }}
          >
            {isRunning ? "关闭假人" : "启动假人"}
          </Button>

          <Button
            icon={<ControlOutlined />}
            onClick={onOpenControl}
            disabled={bot.status !== "在线" || loading}
            style={{
              width: "100%",
              marginBottom: "10px",
              height: "40px",
            }}
          >
            控制假人
          </Button>

          <Button
            icon={<FileTextOutlined />}
            onClick={onOpenLogs}
            loading={loading}
            style={{
              width: "100%",
              marginBottom: "10px",
              height: "40px",
            }}
          >
            查看日志
          </Button>

          <Button
            icon={<SettingOutlined />}
            onClick={onOpenConfig}
            loading={loading}
            style={{ width: "100%", marginBottom: "10px", height: "40px" }}
          >
            配置
          </Button>

          <Button
            icon={<MessageOutlined />}
            onClick={onOpenChats}
            loading={loading}
            style={{ width: "100%", marginBottom: "10px", height: "40px" }}
          >
            查看聊天记录
          </Button>

          <Button
            danger
            type="primary"
            icon={<DeleteOutlined />}
            onClick={() => onDelete(bot)}
            loading={loading}
            style={{ width: "100%", marginTop: "10px", height: "40px" }}
          >
            删除假人
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ManageBotModal;
